import { DataTestIds } from '@repo/frontend-shared';
import { SDSButton } from '@repo/sds/SDSButton';

import './UserProfileFooter.scss';

interface UserProfileFooterProps {
  onClick: () => void;
}

export function UserProfileFooter({ onClick }: UserProfileFooterProps) {
  return (
    <footer className="UserProfileFooter">
      <SDSButton
        dataTestId={DataTestIds.PROFILE.SAVE_CHANGES_BTN}
        type="submit"
        text="Save Changes"
        onClick={onClick}
        ariaLabel="Save profile changes"
      />
    </footer>
  );
}
